// Utilities
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
import { lazy } from "react";
export const PasteFailedDetailsDialogContainerLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "planner-pastefaileddetailsdialogcontainer" */ "./PasteFailedDetailsDialogContainer")).then((bundle)=>{
        return {
            default: bundle.PasteFailedDetailsDialogContainer
        };
    });
export const LazyPasteFailedDetailsDialogContainer = /*#__PURE__*/ lazy(PasteFailedDetailsDialogContainerLazyLoader);
